<div class="sku" [ngClass]="{ plan_error:data?.hasError}">
  <div class="sku_main-wrapper">
    <div class="sku_action sku_action--error" *ngIf="isAdvancePlanning" (click)="itemSelected(data)">
      <i class="far fa-times-circle fa-1x"></i>
    </div>
    <mat-checkbox  *ngIf="!isAdvancePlanning"
    (change)="onChangeSelection()"
    [(ngModel)]="data.sku.checked"
    > </mat-checkbox>
    <div
      class="sku_image"
      [style.backgroundImage]="
        data.sku.Image
          ? 'url(' + data.sku.Image + ')'
          : 'url(' + data.imageUrl + ')'
      "
    ></div>

    <div class="sku_header">
      <div class="sku_title control-label" [matTooltip]="data.sku.Title || data.title ">
        {{ data.sku.Title || data.title }}
      </div>
      <div class="sku_chip-wrapper">
        <app-sku-chip
          [name]="'SKU'"
          [value]="data.sku.Sku || data.sku"
          [link]="
            data.sku.AccountType === 'Amazon' || data.sku.Channel === 'Amazon' 
              ? 'https://sellercentral.amazon.com/myinventory/inventory?searchTerm=' +
                  data.sku.Sku || data.sku
              : 'https://seller.walmart.com/item/list?filters=%257B%2522productOfferId%2522%253A%2522'+  data.sku.Sku || data.sku +'%2522%257D'
                 
          "
        ></app-sku-chip>
        <app-sku-chip
          [name]="'ASIN'"
          [value]="data.sku.Asin || data.asin"
          [link]="
            data.sku.AccountType === 'Amazon' || data.sku.Channel === 'Amazon' 
              ? 'https://amazon.com/dp/' + data.sku.Asin ||
                data.asin + '?th=1&psc=1'
              : 'https://www.walmart.com/ip/' + data.sku.Asin ||
                data.asin + '/?selected=true'
          "
        ></app-sku-chip>
          <app-sku-chip
          *ngIf="data.sku.FnSku"
            [name]="'FNSKU'"
            [value]="data.sku.FnSku || data.FnSku"
          ></app-sku-chip>
      </div>
    </div>
    <div class="sku_label_text">{{data.sku.Prep | titlecase}}</div>
    <span class="sku_edit">
      <i *ngIf="!isAdvancePlanning" (click)="updateFbaType()" matTooltip="Update Fba Type" class="fal fa-edit text-primary"></i>
    </span>
    <svg width="15" height="15" class="sku_placementFee" [matTooltip]="'Inbound Placement Fees'" [matMenuTriggerFor]="placementFee">
      <use xlink:href="assets/images/sprite-icons.svg#searchdollar_icon"></use>
    </svg>
    <mat-menu #placementFee="matMenu" class="placementFee mat-elevation-z0">

    <div class="sku_large-data bg-color-gray"  *ngIf="!data.sku.isMissingDimensions && data.sku.hasFees">
      <div class="w-100 m-auto">
        <div class="sku_large-data_heading">  {{data.sku.categoryName}}</div>
        <div class="sku_large-data_list">
          <span>Minimal</span>
          <span class="text-black"> {{data.sku.minimalShipmentSplitsRange.min | currency}} - {{data.sku.minimalShipmentSplitsRange.max | currency}}
              <i class="fas fa-info-circle sku_large-data_list_info-icon" 
              [matTooltip]="(data.sku.minimalShipmentSplitsRange.min/qtyInput.value)?.toFixed(2)+'-'+(data.sku.minimalShipmentSplitsRange.max/qtyInput.value)?.toFixed(2)+' Per piece'"></i>
          </span>
        </div>
  
        <div  class="sku_large-data_list " >
          <span>Partial</span>
          <span class="text-black"> {{data.sku.partialShipmentSplitsRange.min | currency}} - {{data.sku.partialShipmentSplitsRange.max | currency}}
            <i class="fas fa-info-circle sku_large-data_list_info-icon"
            [matTooltip]="(data.sku.partialShipmentSplitsRange.min/qtyInput.value)?.toFixed(2)+'-'+(data.sku.partialShipmentSplitsRange.max/qtyInput.value)?.toFixed(2)+' Per piece'"></i>
          </span>
        </div>
  
        <div  class="sku_large-data_list">
          <span> Optimized</span>
          <span class="text-black">Free</span>
        </div>
      </div>      
    </div>

    <div class="sku_large-data bg-color-lightyellow p-1" *ngIf="data.sku.isMissingDimensions">
      <div class="text-center w-100 m-auto">
        <p  class="Missing-heading"> Missing Dimensions</p>
        <div class="na-heading"> N/A</div>
      </div>
    </div>
   
    <div class="sku_large-data bg-color-gray p-1" *ngIf="!data.sku.hasFees && !data.sku.isMissingDimensions">      
      <div class="text-center w-100 m-auto">
        <p  class="Missing-heading">{{data.sku.categoryName}}</p>
        <div class="na-heading">FREE</div>
      </div>        
    </div>
    </mat-menu>

    <span class="sku_lock" matTooltip="Lock this item from rounding and only send the original amount" *ngIf="headerService.isNewFlow">
      <i class="fal fa-lock" aria-hidden="true" [ngClass]="data.sku.isQtyLocked ? 'active fas fa-lock' : ''" (click)="data.sku.isQtyLocked = !data.sku.isQtyLocked"></i>
    </span>   
    <div class="sku_actions">
      <div class="input-container" [ngClass]="{'case-qty-input' : isAdvancePlanning }" *ngIf="isCaseQty" >
        <label class="input-container_label">Cases</label>
        <input
          numbersOnly
          type="number"
          class="input-container_input input-container_input--small case-qty"
          [ngClass]="{'case-qty--small': !isAdvancePlanning}"
          [min]="1"
          [max]="qtyInput.value"
          (input)="casesChanged()"
          [formControl]="cases"
        />

        <div *ngIf="cases.errors && isAdvancePlanning" class="caseQty-error">
          <div>
            <span *ngIf="cases.errors.invalidInput && !cases.errors.max">
              <span>&#9888;</span>
              {{cases.errors.invalidInput}}
            </span>
            <span *ngIf="cases.errors.max">
              <span>&#9888;</span>
              Cases can't be more than SKU qty
            </span>
          </div>
        </div>
      </div>
      <div class="input-container" [ngClass]="{'case-qty-input' : isAdvancePlanning }" *ngIf="isCaseQty">
        <label class="input-container_label">Qty Per Case</label>
        <input
          numbersOnly
          type="number"
          class="input-container_input input-container_input--small case-qty"
          [ngClass]="{'case-qty--small': !isAdvancePlanning}"
          [min]="1"
          (input)="casesChanged()"
          [formControl]="caseQtyInput"
        />
        <div *ngIf="caseQtyInput.errors && !isAdvancePlanning" class="qtyInput-error">
          <div>            
            <span *ngIf="caseQtyInput.errors.max">
              <span>&#9888;</span>
             Qty can't be more than 150 per case.
            </span>
          </div>
        </div>
      </div>
      <div class="input-container" [ngClass]="{'case-qty-input' : isAdvancePlanning }" *ngIf="!isCaseQty">
        <label class="input-container_label">Total Qty</label>
        <input
          numbersOnly
          type="number"
          class="input-container_input input-container_input--small case-qty"
          [ngClass]="{'case-qty--small': !isAdvancePlanning}"
          [min]="data.minQty || 1"
          [formControl]="qtyInput"
          (input)="qtyChanged($event)"
          [matTooltip]="isAdvancePlanning ? 'Total Qty' : ''"
        />       
      </div>
      <div class="input-container ps-3" *ngIf="isCaseQty">
        <label class="input-container_label">Total</label>
        <div class="totalQty">{{qtyInput.value}}</div>
      </div>
    </div>
    <div class="sku_actions-devider" *ngIf="!isWalmart && isAdvancePlanning"></div>
    <app-button 
      [buttonSize]="'action'"
      [buttonStyle]="data.planned && !data.spinLoader ? 'down-arrow' : 'wire'"
      [buttonColor]="data?.hasError ? 'accent' : 'primary'"
      (click)="toggleTable()"
      [spin]="data.spinLoader"
      [isDisabled]="isPlanDisabled || data.planned || qtyInput.invalid || (isCaseQty && caseQtyInput?.invalid)"
      *ngIf="!isWalmart && isAdvancePlanning"
      class="sku_actions-btn"
    >
    <i class="far fa-check" *ngIf="data.planned && !data.spinLoader"></i>
    {{
      data.spinLoader
      ? "Planning"
      : data.planned
      ? "Planned"
      : data?.hasError
      ? "Plan Again"
      : "Plan"
    }}
    </app-button>
    <div *ngIf="!isAdvancePlanning" class="sku_action sku_action--error" (click)="itemSelected(data)">
      <i class="far fa-times-circle fa-1x"></i>
    </div>
  </div>
  <div class="data-table table-sticy-scroll thin-scrollbars" *ngIf="data.showTable && isAdvancePlanning">
    <table>
      <thead>
        <tr>
          <th>WH ID</th>
          <th>Qty</th>
          <th>State</th>
          <th>Mile</th>
          <th width="220">Shipment name</th>
          <th width="120">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="data-show"
          *ngIf="data.shipmentPlan?.length > 1"
          (click)="expandDetails()"
        >
          <td>{{ data.multiPlanHeaderRowData.plans }}</td>
          <td>{{ data.multiPlanHeaderRowData.qty }}</td>
          <td>Multiple</td>
          <td>-</td>
          <td></td>
          <td class="data-show_btn">
            <div>
              <app-button
                *ngIf="!expand"
                class="plan-shipment_text"
                [buttonStyle]="'text'"
                [buttonSize]="'action'"
                [buttonColor]="'primary'"
                >See all <i class="far fa-chevron-down fa-1x"></i
              ></app-button>
              <app-button
                *ngIf="expand"
                class="plan-shipment_text"
                [buttonStyle]="'text'"
                [buttonSize]="'action'"
                [buttonColor]="'primary'"
                >hide <i class="far fa-chevron-up fa-1x"></i
              ></app-button>
            </div>
          </td>
        </tr>
        <tr
          class="data-open"
          *ngFor="let plan of data.shipmentPlan; let i = index"
          (click)="selectShipment(plan, i)"
          [ngClass]="{
            toggle: data.shipmentPlan?.length > 1 && !expand,
            selected:
              (selectedShipment &&
                plan.shipmentId === selectedShipment?.shipmentId) ||
              data.shipmentPlan?.length == 1
          }"
        >
          <td>{{ plan.destinationId }}</td>
          <td>{{ plan.qty }}</td>
          <td>{{ plan.shipTo }}</td>
          <td>N/A</td>
          <td>
            <input
              id="date"
              type="text"
              [(ngModel)]="plan.shipmentName"
              class="form-control form-control-sm"
              (click)="stopPropagation($event)"
            />
          </td>
          <td>
            <span *ngIf="data.shipmentPlan?.length > 1; else elseBlock">
              Add all here
            </span>
            <ng-template #elseBlock>
              <div class="add-btn">
                <app-button
                  *ngIf="data.shipmentPlan?.length === 1"
                  [buttonStyle]="'wire'"
                  [buttonSize]="'action'"
                  [buttonColor]="'primary'"
                  (click)="
                    mergeShipment(data.shipmentPlan, plan.shipmentPlanHeaderId)
                  "
                  [spin]="isLoading"
                  >Create and Add</app-button
                >
              </div>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="sku_btn-wrap align-items-center mt-3"
      *ngIf="data.shipmentPlan?.length > 1"
    >
      <app-button
        [buttonStyle]="'wire'"
        [buttonSize]="'action'"
        [buttonColor]="'primary'"
        (click)="
          mergeShipment(
            data.shipmentPlan,
            selectedShipment.shipmentPlanHeaderId
          )
        "
        [spin]="isLoading"
        [isDisabled]="!selectedShipment"
        >Create</app-button
      >
    </div>
  </div>
</div>
<div *ngIf="data?.hasError" class="error">{{data.errorMessage}}</div>
